import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import ReviewItemModel from 'donor-elf-web/models/review-item';
import CampaignService from 'donor-elf-web/services/campaign-service';

interface ComponentArgs {
  reviewItem: ReviewItemModel;
  onSave: (reviewItem: ReviewItemModel) => void;
}

export default class ReviewItemCardDuplicatePledgesComponent extends Component<ComponentArgs> {
  @service declare campaignService: CampaignService;

  @tracked selectPledgeToKeep = false;
  @tracked saving = false;
  @tracked saveError?: any;
  @tracked pledgeIdToKeep?: any;
  @tracked campaignIdToKeep?: any;

  get canMerge() {
    return (
      this.pledgeIdToKeep != null &&
      (!this.showCampaignSelection || this.campaignIdToKeep != null)
    );
  }

  get pledgeInfo1() {
    return this.args.reviewItem.custom['pledges'][0];
  }

  get pledgeInfo2() {
    return this.args.reviewItem.custom['pledges'][1];
  }

  get onePledgeHasHostIdentity() {
    return this.args.reviewItem.custom['pledges'].some(
      (x: any) => x.has_host_identity,
    );
  }

  preventTheTableFromExpanding(e: any) {
    let table = e.querySelector('table');
    table.style.width = `${table.getBoundingClientRect().width}px`;
  }

  get showCampaignSelection() {
    return (
      this.campaignService.campaignsEnabled &&
      this.pledgeInfo1.campaign_id != null &&
      this.pledgeInfo2.campaign_id != null &&
      this.pledgeInfo1.campaign_id !== this.pledgeInfo2.campaign_id
    );
  }

  @action
  templateDidInsert(e: any) {
    this.preventTheTableFromExpanding(e);
  }

  handleCampaignSelection = (campaignId: any, event: any) => {
    let isChecked = event.target.checked;
    this.campaignIdToKeep = isChecked ? campaignId : null;
  };

  @action
  async handleNo() {
    this.saving = true;
    this.args.reviewItem.answered = true;
    await this.args.reviewItem.save();
    this.args.onSave(this.args.reviewItem);
  }

  @action
  async handleYes() {
    this.pledgeIdToKeep = null;
    this.campaignIdToKeep =
      this.pledgeInfo1.campaign_id || this.pledgeInfo2.campaign_id;
    this.selectPledgeToKeep = true;
  }

  handleSelectPledgeToKeep = (pledgeInfo: any, event: any) => {
    const isChecked = event.target.checked;
    this.pledgeIdToKeep = isChecked ? pledgeInfo.id : null;
  };

  handleMerge = async () => {
    this.saving = true;
    this.args.reviewItem.answered = true;
    this.args.reviewItem.saveCommand = {
      pledge_id_to_keep: this.pledgeIdToKeep,
      campaign_id_to_keep: this.campaignIdToKeep,
    };
    try {
      await this.args.reviewItem.save();
      this.args.onSave(this.args.reviewItem);
    } catch (error) {
      this.saveError = error;
    }
  };

  @action
  async handleCancelSelectPledgeToKeep() {
    this.selectPledgeToKeep = false;
  }
}
